// extracted by mini-css-extract-plugin
module.exports = {"button":"NewOnboarding_button__2giGu","title":"NewOnboarding_title__3A5DQ","wrap":"NewOnboarding_wrap__kq03i"};